// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvoiceHeader } from './invoice-header';
import { ShipmentStatus } from './shipment-status';
import { ShippingBox } from './shipping-box';
import { ShipmentStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Shipment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // assumes that shippingBoxs->invoices have been expanded.

  get weightUoMId() {
    if (this.shippingBoxes?.length > 0) {
      return this.shippingBoxes[0].weightUoMId;
    } else {
      return null;
    }
  }

  get trackingNumbers() {
    const r = this.shippingBoxes
      .filter(sb => sb.trackingLabelApiIdentifier != null)
      .map(sb => sb.trackingLabelApiIdentifier?.trim());
    return r.length > 0 ? r.join(', ') : null;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(255) */
  carrierApiIdentifier?: string;
  /** Decimal */
  freightAmt?: number;
  /** Decimal */
  insuranceAmt?: number;
  /** Boolean */
  isPickup!: boolean;
  /** String(255) */
  labelApiIdentifier?: string;
  /** DateTimeOffset */
  modTs?: Date;
  /** String(10) */
  primaryInvoiceHeaderId?: string;
  /** DateTimeOffset */
  receivedTs?: Date;
  /** Binary */
  rowVersion!: any;
  /** String(255) */
  serviceApiIdentifier?: string;
  /** DateTimeOffset */
  shipTs?: Date;
  /** String(255) */
  shipmentApiIdentifier?: string;
  /** Enum FK shipmentStatus */
  shipmentStatusId?: ShipmentStatusEnum;
  /** String(4000) */
  trackingUrl?: string;
  /** Inv FK shipmentId */
  invoiceHeaders!: InvoiceHeader[];
  /** FK shipmentStatusId */
  shipmentStatus!: ShipmentStatus;
  /** Inv FK shipmentId */
  shippingBoxes!: ShippingBox[];
}

